<div class="order-list-container">
  <h2>Order List</h2>

  <table class="order-table">
    <thead>
      <tr>
        <th>Order ID</th>
        <th>Date</th>
        <th>Customer</th>
        <th>Total Amount</th>
        <th>Status</th>
        <th>Payment Method</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let order of orders">
        <td>{{ order.orderId }}</td>
        <td>{{ order.date }}</td>
        <td>{{ order.customerName }}</td>
        <td>{{ order.totalAmount }}</td>
        <td class="status {{ order.status.toLowerCase() }}">
          {{ order.status }}
        </td>
        <td>{{ order.paymentMethod }}</td>
      </tr>
      <tr *ngIf="orders.length === 0">
        <td colspan="6">No orders available</td>
      </tr>
    </tbody>
  </table>
</div>
